import { T_PRIVACY_POLICY_PAGE_CONSTANTS } from './TYPES'

const FR_PRIVACY_POLICY_PAGE_CONSTANTS: T_PRIVACY_POLICY_PAGE_CONSTANTS = {
  PAGE_KICKER: 'GRIFFYREADS',
  PAGE_TITLE: 'Politique de confidentialité',
  PAGE_CONTENT: [
    {
      TITLE: 'Introduction',
      CONTENT: [
        {
          TYPE: 'TEXT',
          CONTENT: [
            "ADONIS CONSULTANCY, en tant que propriétaire et exploitant du site www.griffyreads.com et de l'application correspondante GriffyReads (« l'Application »), informe les visiteurs et les utilisateurs enregistrés de ses pratiques de traitement des données, des mesures techniques et organisationnelles appropriées mises en œuvre pour protéger les données personnelles et des recours juridiques disponibles pour les utilisateurs.",
            'Cette politique de confidentialité explique comment vos données personnelles sont collectées, utilisées et protégées.',
            "En s'inscrivant à l'Application et en créant un compte, les utilisateurs adultes donnent leur consentement explicite au traitement de leurs données personnelles et, le cas échéant, au traitement des données personnelles de tout enfant pour lequel ils créent un compte (compte lié), conformément à la présente Politique de confidentialité."
          ]
        }
      ]
    },
    {
      TITLE: 'Le responsable du traitement',
      CONTENT: [
        {
          TYPE: 'TEXT',
          CONTENT: [
            'Le responsable du traitement des données est ADONIS CONSULTANCY (siège: Belgique, 1170 Watermael-Boitsfort, 16 avenue de l’Hermine), numéro fiscal: BE 0553 528 124, représentée par le fondateur Ralph EL KHOURY (ci-après le «responsable du traitement»).',
            'Toutes les données à caractère personnel collectées par l’intermédiaire des services du responsable du traitement sont stockées et traitées de manière sécurisée sur des serveurs hébergés par Amazon Web Services (AWS) dans la région Europe (Irlande) (eu-west-1). En conséquence, toutes les données à caractère personnel sont stockées dans l’Espace économique européen (EEE) et sont protégées par la législation de l’UE en matière de protection des données, y compris le règlement (UE) 2016/679 du Parlement européen et du Conseil du 27 avril 2016 relatif à la protection des personnes physiques à l’égard du traitement des données à caractère personnel et à la libre circulation de ces données (ci-après le «RGPD»).'
          ]
        }
      ]
    },
    {
      TITLE:
        'Les données traitées par le responsable du traitement et les objectifs du traitement des données',
      CONTENT: [
        {
          TYPE: 'TEXT',
          CONTENT: [
            ' ',
            ' ',
            ' ',
            "a)	Informations au moment de l'inscription:",
            "L’application est destinée à être utilisée à la fois par des adultes et des enfants (dans l’application, les enfants enregistrés sont appelés «aventuriers»; les adultes enregistrés et les enfants sont collectivement appelés «utilisateurs»). Les utilisateurs accèdent à l'application via des comptes individuels.",
            ' ',
            "Seuls les adultes sont autorisés à initier la création de compte en s'inscrivant à l'application. Lors de l'inscription, les utilisateurs adultes sont tenus de fournir leur nom complet, leur date de naissance, leur langue préférée, leur adresse e-mail, leur mot de passe et leur nom d'utilisateur. Une fois leur compte créé, les adultes peuvent créer des comptes liés pour leurs enfants ou leurs étudiants en fournissant le même ensemble d'informations. Une fois que le compte d’un enfant a été créé, l’enfant peut se connecter et accéder à l’application de manière indépendante.",
            ' ',
            ' ',
            'Ces données sont utilisées:',
            ' '
          ]
        },
        {
          TYPE: 'LIST',
          CONTENT: [
            "Pour donner accès à l'application et activer la connexion",
            "Maintenir et exploiter des comptes d'utilisateurs",
            "Personnaliser l'expérience utilisateur, y compris la progression des personnages et les classements"
          ]
        },
        {
          TYPE: 'TEXT',
          CONTENT: [' ', ' ', 'Base juridique:', ' ']
        },
        {
          TYPE: 'LIST',
          CONTENT: [
            "Article 6, paragraphe 1, point b), du RGPD – Contrat: Le traitement est nécessaire à l'exécution d'un contrat (fournissant l'accès et l'utilisation de l'Application).",
            "Article 6, paragraphe 1, point f), du RGPD – Intérêt légitime du responsable du traitement: Assurer le bon fonctionnement des comptes d'utilisateurs et prévenir les abus.",
            "En ce qui concerne les données personnelles des enfants de moins de 13 ans, conformément à l'article 8 du RGPD et au droit belge, le consentement parental est requis. Cela est garanti en exigeant que seul un adulte puisse créer un compte pour un enfant dans l’application et que cet adulte fournisse les données à caractère personnel nécessaires au nom de l’enfant."
          ]
        },
        {
          TYPE: 'TEXT',
          CONTENT: [
            ' ',
            ' ',
            ' ',
            'b)	Données relatives aux quiz:',
            ' ',
            "Afin de tester la compréhension en lecture d'un livre, les utilisateurs adultes téléchargent des quiz composés de questions à choix multiple. Après approbation par un administrateur, les quiz sont stockés dans l'application et deviennent disponibles pour tous les utilisateurs. L'application stocke des informations sur les résultats d'un aventurier, y compris les points gagnés et les progrès.",
            ' ',
            ' ',
            'Ces données sont utilisées:',
            ' '
          ]
        },
        {
          TYPE: 'LIST',
          CONTENT: [
            'Fournir les fonctionnalités de base de l’application (quizzes et suivi des progrès)',
            'Soutenir les fonctionnalités éducatives et interactives'
          ]
        },
        {
          TYPE: 'TEXT',
          CONTENT: [' ', ' ', 'Base juridique:', ' ']
        },
        {
          TYPE: 'LIST',
          CONTENT: [
            "Article 6, paragraphe 1, point b), du RGPD – Contrat: Pour fournir les fonctionnalités de base de l'application (quizzes et suivi des progrès).",
            "Article 6, paragraphe 1, point f), du RGPD – Intérêt légitime du responsable du traitement: Pour soutenir les objectifs éducatifs et interactifs de l'application."
          ]
        },
        {
          TYPE: 'TEXT',
          CONTENT: [
            ' ',
            ' ',
            ' ',
            'c)	Données relatives aux livres détenus:',
            ' ',
            "L'application stocke les données d'identification des livres que les enfants indiquent posséder dans leur bibliothèque et permet leur échange entre enfants, favorisant ainsi la durabilité en encourageant l'emprunt de livres.",
            ' ',
            ' ',
            'Ces dates sont utilisées:',
            ' '
          ]
        },
        {
          TYPE: 'LIST',
          CONTENT: [
            'Pour offrir la fonction de bibliothèque virtuelle',
            "Faciliter l'échange de livres et promouvoir l'emprunt"
          ]
        },
        {
          TYPE: 'TEXT',
          CONTENT: [' ', ' ', 'Base juridique:', ' ']
        },
        {
          TYPE: 'LIST',
          CONTENT: [
            "Article 6, paragraphe 1, point b), du RGPD – Contrat: Offrir la fonction de bibliothèque et d'échange de livres.",
            "Article 6, paragraphe 1, point f), du RGPD – Intérêt légitime du responsable du traitement: Promouvoir la durabilité et l'interaction sociale par le partage de livres."
          ]
        },
        {
          TYPE: 'TEXT',
          CONTENT: [
            ' ',
            ' ',
            ' ',
            'd)	Communications:',
            ' ',
            "Le responsable du traitement recueille des informations à partir d'e-mails et de notifications push envoyés à des fins statistiques.",
            ' ',
            ' ',
            'Ces données sont utilisées:',
            ' '
          ]
        },
        {
          TYPE: 'LIST',
          CONTENT: [
            'Pour envoyer des mises à jour et des informations sur les événements et les compétitions',
            "Analyser l'efficacité de la communication et améliorer l'application."
          ]
        },
        {
          TYPE: 'TEXT',
          CONTENT: [' ', ' ', 'Base juridique:', ' ']
        },
        {
          TYPE: 'LIST',
          CONTENT: [
            "Article 6, paragraphe 1, point f), du RGPD – Intérêt légitime du responsable du traitement: Pour analyser l'efficacité de la communication et améliorer l'application."
          ]
        },
        {
          TYPE: 'TEXT',
          CONTENT: [
            ' ',
            ' ',
            ' ',
            'e)	Informations de paiement',
            ' ',
            "Les paiements des frais d'abonnement sont traités via PayPal. Aucune donnée de paiement n’est stockée sur la plateforme du responsable du traitement."
          ]
        }
      ]
    },
    {
      TITLE: 'Partage de vos données personnelles',
      CONTENT: [
        {
          TYPE: 'TEXT',
          CONTENT: [
            "Le responsable du traitement ne vend pas, n'échange pas ou ne transfère pas vos données personnelles à des tiers, sauf si cela est nécessaire pour fournir les services de l'application, pour se conformer aux exigences légales en vigueur ou pour protéger ses droits."
          ]
        }
      ]
    },
    {
      TITLE: 'Sécurité des données',
      CONTENT: [
        {
          TYPE: 'TEXT',
          CONTENT: [
            'Le responsable du traitement met en œuvre des mesures de sécurité appropriées pour protéger vos informations personnelles contre tout accès, altération, divulgation ou destruction non autorisés.'
          ]
        }
      ]
    },
    {
      TITLE: 'Vos droits',
      CONTENT: [
        {
          TYPE: 'TEXT',
          CONTENT: [
            "Vous avez le droit de demander au responsable du traitement l'accès et la rectification ou l'effacement de vos données à caractère personnel. Vous pouvez également vous opposer ou limiter le traitement de vos données. Pour exercer ces droits, veuillez contacter le responsable du traitement à contact@griffyreads.com."
          ]
        }
      ]
    },
    {
      TITLE: 'Modifications apportées à cette politique de confidentialité',
      CONTENT: [
        {
          TYPE: 'TEXT',
          CONTENT: [
            "Le responsable du traitement peut mettre à jour cette politique de confidentialité de temps à autre. Le responsable du traitement vous informera de tout changement en publiant la nouvelle politique sur son site web. Votre utilisation continue de l'application après de telles modifications indique votre acceptation de la nouvelle politique de confidentialité."
          ]
        }
      ]
    },
    {
      TITLE: 'Contactez-nous',
      CONTENT: [
        {
          TYPE: 'TEXT',
          CONTENT: [
            'Si vous avez des questions ou des préoccupations concernant cette politique de confidentialité, veuillez contacter le responsable du traitement à contact@griffyreads.com.'
          ]
        }
      ]
    },
    {
      TITLE: 'Droit d’introduire une réclamation',
      CONTENT: [
        {
          TYPE: 'TEXT',
          CONTENT: [
            "Si vous considérez que le traitement des données à caractère personnel vous concernant constitue une violation des lois applicables en matière de protection des données, vous avez le droit d'introduire une réclamation auprès d'une autorité de contrôle.",
            '',
            '',
            "En Belgique, l'autorité compétente est:",
            'Autorité belge de protection des données',
            'Rue de la Presse 35, 1000 Bruxelles',
            '',
            '',
            'Site web: https://www.dataprotectionauthority.be',
            '',
            '',
            '',
            'Cette politique de confidentialité est en vigueur à partir du 05 mai 2025.'
          ]
        }
      ]
    }
  ]
}

export default FR_PRIVACY_POLICY_PAGE_CONSTANTS
